import { render, staticRenderFns } from "./RoundRobinBracket.vue?vue&type=template&id=a9cf6c5c&scoped=true&"
import script from "./RoundRobinBracket.vue?vue&type=script&lang=js&"
export * from "./RoundRobinBracket.vue?vue&type=script&lang=js&"
import style0 from "./RoundRobinBracket.vue?vue&type=style&index=0&id=a9cf6c5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cf6c5c",
  null
  
)

export default component.exports